import React from "react"
import PropTypes from "prop-types"

const Leaderboard = ({
    width, height, color, className,
}) => (
    <svg className={className} width={width} height={height} viewBox="0 0 25 24">
        <title>Leaderboard</title>
        <g
            transform="translate(-243 -24) translate(232) translate(11.367 24)"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <path d="M0 0H24V24H0z" />
            <path
                d="M7.5 21H2V9h5.5v12zm7.25-18h-5.5v18h5.5V3zM22 11h-5.5v10H22V11z"
                fill={color}
            />
        </g>
    </svg>
)

Leaderboard.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string,
    className: PropTypes.string,
}

Leaderboard.defaultProps = {
    width: 25,
    height: 24,
    color: "#fff",
    className: "",
}

export default Leaderboard
